import * as React from "react";

export const LivingIcon = (props: any) => (
  <svg
    width={10}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.881 13.929V3.41L.357.293v19.25h6.468l3.032-5.614H5.88Z"
      fill="#242C57"
    />
  </svg>
);
